module.exports = __webpack_public_path__ + "img/sa.a3a2056.svg";